import React, { Component } from 'react';

import { translate } from "react-translate"

import MenuComponent from '../MenuComponent';
import FooterComponent from '../FooterComponent';

import {
    Container,
    Grid,
    Segment,
    Image,
    Header
} from 'semantic-ui-react';
import './fonction.css'
import image_hero from '../../../assets/img/fonction.png';
import image_1 from '../../../assets/img/fonction_1.png';
import image_2 from '../../../assets/img/fonction_2.png';
import image_3 from '../../../assets/img/fonction_3.png';
import image_4 from '../../../assets/img/fonction_4.png';
import image_5 from '../../../assets/img/fonction_5.png';
import image_6 from '../../../assets/img/fonction_6.png';
import image_7 from '../../../assets/img/fonction_7.png';
import image_8 from '../../../assets/img/fonction_8.png';
import image_9 from '../../../assets/img/fonction_9.png';
import image_10 from '../../../assets/img/fonction_10.png';
import mur from '../../../assets/tmp/Murs_icon.png';

class FonctionComponent extends Component {

  render() {

    const { t } = this.props

    return (
        <div>
            <MenuComponent />
            <Segment vertical id="sectionFonction" >
                <Image
                    src={image_hero}
                    id="sectionFonctionImage"
                    fluid />
                <div id="containerFonction">
                    <Container textAlign='center'>
                        <Header size='huge' as='h1' id="ContainerFonctionTitre">{t("Segment1_title")}</Header>
                    </Container>

                    <Container textAlign='center'>
                        <p id="ContainerFonctionDescription">
                            {t("Segment1_description")}
                        </p>
                    </Container>
                </div>
            </Segment>

            <Segment vertical id="sectionFonctionContent" >
                <Container>
                    <Grid centered stackable columns={3}>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_1} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_1")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_2} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_2")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_3} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_3")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_4} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_4")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_5} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_5")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_6} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_6")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_7} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_7")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_8} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_8")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_9} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_9")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column id="sectionFonctionContentColumn">
                            <Image src={image_10} />
                            <div id="containerImage">
                                <Container textAlign='center' id="sectionFonctionContainer">
                                    <Header as='p' id="sectionFonctionContentDescription">{t("Segment2_image_10")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                    </Grid>
                </Container>
            </Segment>
            <FooterComponent />
        </div>
    );
  }
}


export default translate("FonctionComponent")(FonctionComponent);



// WEBPACK FOOTER //
// ./src/components/Public/FonctionPage/FonctionComponent.js